import { Observable, forkJoin } from 'rxjs'
import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { SerieProposalItemSerializer } from './serie-proposal-item.serializer'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { Booking } from '../../../booking/booking'
import moment from 'moment-mini'
import { productSelectors } from '../../../product/product.selectors'
import { take } from 'rxjs/operators'
import { SerieProposalItem } from './serie-proposal-item'

@Injectable()
export class SerieProposalItemService extends ResourceService<SerieProposalItem> {
  // TODO create some resource service to extend that works for services like this
  constructor(
    public http: HttpClient,
    public serializer: SerieProposalItemSerializer,
    private store: Store<AppState>
  ) {
    super(http, `${environment.backendApiUrl}/serie-proposal-items`, serializer)
  }

  public updateOneByParams(
    serieProposalItemId: number,
    updateParams: Partial<SerieProposalItem>
  ): Observable<SerieProposalItem> {
    let postBody = { ...updateParams }

    return this.http.patch<SerieProposalItem>(
      `${environment.backendApiUrl}/serie-proposal-items/${serieProposalItemId}`,
      postBody
    )
  }

  public updateManyByParams(
    updateParams: Partial<SerieProposalItem>[]
  ): Observable<SerieProposalItem[]> {
    const paramsMappedToObservables = updateParams.map((param) =>
      this.updateOneByParams(param.id, param)
    )

    return forkJoin(paramsMappedToObservables)
  }

  public hasConflictingBooking(
    serieProposalItem: SerieProposalItem,
    allBookings: Booking[]
  ): boolean {
    if (!serieProposalItem || !allBookings?.length) {
      return false
    }

    let hasConflict = false

    this.store
      .select(productSelectors.selectEntities)
      .pipe(take(1))
      .subscribe((productEntities) => {
        const intersectingBooking = allBookings.find((booking) => {
          return (
            (booking.productId == serieProposalItem.productId ||
              productEntities[
                serieProposalItem.productId
              ].dependantProducts?.includes(booking.productId)) &&
            moment(serieProposalItem.startDate).isSameOrBefore(
              booking.endDate
            ) &&
            moment(serieProposalItem.endDate).isSameOrAfter(booking.startDate)
          )
        })

        return (hasConflict = Boolean(intersectingBooking))
      })

    return hasConflict
  }
}
